import $ from "../../global/util";

export default {
  SEND_FEEDBACK: {
    PATH: "/feedback.json",
  },
};
